import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-senior-ranking-classif',
  templateUrl: './senior-ranking-classif.component.html',
  styleUrls: ['./senior-ranking-classif.component.scss']
})

export class SeniorRankingClassifComponent implements OnInit {
  /**
   * Definição para receber o identificador do ranking
   */
  rankingId: string;

  constructor(private route: ActivatedRoute) {}

  ngOnInit(): void {
      this.rankingId = this.route.snapshot.paramMap.get('rankingId');
  }
}
